import { render } from "./DayAccount.vue?vue&type=template&id=2b2d0edf&scoped=true"
import script from "./DayAccount.vue?vue&type=script&lang=js"
export * from "./DayAccount.vue?vue&type=script&lang=js"

import "./DayAccount.vue?vue&type=style&index=0&id=2b2d0edf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b2d0edf"

export default script